import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../colorVars';
import { activateTradePlan } from '../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/activateTradePlan';
import { removeTradePlan } from '../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/removeTradePlan';
import { useAlertsStore } from '../../../../../../stores/websocketStore/_alertsStore';
import TextButton from '../../../../../atomic/buttons/textButton/TextButton';
import style from '../AlertWatchlistComponent.module.css';

export const AlertWatchlistComponentControls = observer(
  ({ selectedAlert, selectedWatchlist }) => {
    const alertStore = useAlertsStore();
    const alert = alertStore.alertTradePlansById[selectedAlert] ?? null;
    return (
      <div className={style.bottomControls}>
        <TextButton
          disabled={
            !selectedAlert ||
            !alert?.restartSystemOncePositionHasFlattened ||
            !alert?.restartSettings.deactivated
          }
          fontSize="small"
          color={colors.lightGrey}
          width="110px"
          height="100%"
          backgroundColor={           !selectedAlert ||
            !alert?.restartSystemOncePositionHasFlattened ||
            !alert?.restartSettings.deactivated ? colors.grey : colors.blue}
          clickHandler={() => {
            if (selectedAlert) {
              if (
                alert?.restartSystemOncePositionHasFlattened &&
                alert?.restartSettings.deactivated
              ) {
                activateTradePlan(selectedAlert, true);
              }
            }
          }}
        >
          Activate Selected
        </TextButton>
        <TextButton
          fontSize="small"
          color={colors.lightGrey}
          width="110px"
          height="100%"
          backgroundColor={colors.red}
          clickHandler={() => {
            if (selectedAlert) removeTradePlan(selectedAlert);
          }}
        >
          Remove Selected
        </TextButton>
        <TextButton
          fontSize="small"
          color={colors.lightGrey}
          width="110px"
          height="100%"
          backgroundColor={colors.red}
          clickHandler={() => {
            alertStore.clearWatchlist(selectedWatchlist);
          }}
        >
          Remove All
        </TextButton>
      </div>
    );
  }
);

AlertWatchlistComponentControls.propTypes = {
  selectedAlert: PropTypes.any,
  selectedWatchlist: PropTypes.any,
};
